// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type GetLogDrainIntegrationByProviderAndSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  logDrainProvider: Types.LogDrainProvider;
}>;


export type GetLogDrainIntegrationByProviderAndSiteQuery = (
  { __typename?: 'Query' }
  & { getLogDrainIntegrationByProviderAndSite?: Types.Maybe<(
    { __typename?: 'LogDrainIntegration' }
    & Pick<Types.LogDrainIntegration, 'id' | 'siteId' | 'logDrainProvider' | 'lastDrainedAt' | 'config' | 'error'>
  )> }
);

export type CreateLogDrainIntegrationMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  logDrainProvider: Types.LogDrainProvider;
  config: Types.Scalars['JSON'];
}>;


export type CreateLogDrainIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { createLogDrainIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);

export type UpdateLogDrainIntegrationMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  integrationId: Types.Scalars['UUID'];
  config: Types.Scalars['JSON'];
}>;


export type UpdateLogDrainIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { updateLogDrainIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);

export type DeleteLogDrainIntegrationMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  integrationId: Types.Scalars['UUID'];
}>;


export type DeleteLogDrainIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { deleteLogDrainIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);


export const GetLogDrainIntegrationByProviderAndSiteDocument = gql`
    query getLogDrainIntegrationByProviderAndSite($siteId: UUID!, $logDrainProvider: LogDrainProvider!) {
  getLogDrainIntegrationByProviderAndSite(
    siteId: $siteId
    logDrainProvider: $logDrainProvider
  ) {
    id
    siteId
    logDrainProvider
    lastDrainedAt
    config
    error
  }
}
    `;

/**
 * __useGetLogDrainIntegrationByProviderAndSiteQuery__
 *
 * To run a query within a React component, call `useGetLogDrainIntegrationByProviderAndSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogDrainIntegrationByProviderAndSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogDrainIntegrationByProviderAndSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      logDrainProvider: // value for 'logDrainProvider'
 *   },
 * });
 */
export function useGetLogDrainIntegrationByProviderAndSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLogDrainIntegrationByProviderAndSiteQuery, GetLogDrainIntegrationByProviderAndSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLogDrainIntegrationByProviderAndSiteQuery, GetLogDrainIntegrationByProviderAndSiteQueryVariables>(GetLogDrainIntegrationByProviderAndSiteDocument, baseOptions);
      }
export function useGetLogDrainIntegrationByProviderAndSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLogDrainIntegrationByProviderAndSiteQuery, GetLogDrainIntegrationByProviderAndSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLogDrainIntegrationByProviderAndSiteQuery, GetLogDrainIntegrationByProviderAndSiteQueryVariables>(GetLogDrainIntegrationByProviderAndSiteDocument, baseOptions);
        }
export type GetLogDrainIntegrationByProviderAndSiteQueryHookResult = ReturnType<typeof useGetLogDrainIntegrationByProviderAndSiteQuery>;
export type GetLogDrainIntegrationByProviderAndSiteLazyQueryHookResult = ReturnType<typeof useGetLogDrainIntegrationByProviderAndSiteLazyQuery>;
export type GetLogDrainIntegrationByProviderAndSiteQueryResult = ApolloReactCommon.QueryResult<GetLogDrainIntegrationByProviderAndSiteQuery, GetLogDrainIntegrationByProviderAndSiteQueryVariables>;
export const CreateLogDrainIntegrationDocument = gql`
    mutation createLogDrainIntegration($siteId: UUID!, $logDrainProvider: LogDrainProvider!, $config: JSON!) {
  createLogDrainIntegration(
    siteId: $siteId
    logDrainProvider: $logDrainProvider
    config: $config
  ) {
    success
    message
    errorType
  }
}
    `;
export type CreateLogDrainIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateLogDrainIntegrationMutation, CreateLogDrainIntegrationMutationVariables>;

/**
 * __useCreateLogDrainIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateLogDrainIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogDrainIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogDrainIntegrationMutation, { data, loading, error }] = useCreateLogDrainIntegrationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      logDrainProvider: // value for 'logDrainProvider'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useCreateLogDrainIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLogDrainIntegrationMutation, CreateLogDrainIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLogDrainIntegrationMutation, CreateLogDrainIntegrationMutationVariables>(CreateLogDrainIntegrationDocument, baseOptions);
      }
export type CreateLogDrainIntegrationMutationHookResult = ReturnType<typeof useCreateLogDrainIntegrationMutation>;
export type CreateLogDrainIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateLogDrainIntegrationMutation>;
export type CreateLogDrainIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLogDrainIntegrationMutation, CreateLogDrainIntegrationMutationVariables>;
export const UpdateLogDrainIntegrationDocument = gql`
    mutation updateLogDrainIntegration($siteId: UUID!, $integrationId: UUID!, $config: JSON!) {
  updateLogDrainIntegration(
    siteId: $siteId
    integrationId: $integrationId
    config: $config
  ) {
    success
    message
    errorType
  }
}
    `;
export type UpdateLogDrainIntegrationMutationFn = ApolloReactCommon.MutationFunction<UpdateLogDrainIntegrationMutation, UpdateLogDrainIntegrationMutationVariables>;

/**
 * __useUpdateLogDrainIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateLogDrainIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogDrainIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogDrainIntegrationMutation, { data, loading, error }] = useUpdateLogDrainIntegrationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      integrationId: // value for 'integrationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateLogDrainIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLogDrainIntegrationMutation, UpdateLogDrainIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLogDrainIntegrationMutation, UpdateLogDrainIntegrationMutationVariables>(UpdateLogDrainIntegrationDocument, baseOptions);
      }
export type UpdateLogDrainIntegrationMutationHookResult = ReturnType<typeof useUpdateLogDrainIntegrationMutation>;
export type UpdateLogDrainIntegrationMutationResult = ApolloReactCommon.MutationResult<UpdateLogDrainIntegrationMutation>;
export type UpdateLogDrainIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLogDrainIntegrationMutation, UpdateLogDrainIntegrationMutationVariables>;
export const DeleteLogDrainIntegrationDocument = gql`
    mutation deleteLogDrainIntegration($siteId: UUID!, $integrationId: UUID!) {
  deleteLogDrainIntegration(siteId: $siteId, integrationId: $integrationId) {
    success
    message
    errorType
  }
}
    `;
export type DeleteLogDrainIntegrationMutationFn = ApolloReactCommon.MutationFunction<DeleteLogDrainIntegrationMutation, DeleteLogDrainIntegrationMutationVariables>;

/**
 * __useDeleteLogDrainIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteLogDrainIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogDrainIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogDrainIntegrationMutation, { data, loading, error }] = useDeleteLogDrainIntegrationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDeleteLogDrainIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLogDrainIntegrationMutation, DeleteLogDrainIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteLogDrainIntegrationMutation, DeleteLogDrainIntegrationMutationVariables>(DeleteLogDrainIntegrationDocument, baseOptions);
      }
export type DeleteLogDrainIntegrationMutationHookResult = ReturnType<typeof useDeleteLogDrainIntegrationMutation>;
export type DeleteLogDrainIntegrationMutationResult = ApolloReactCommon.MutationResult<DeleteLogDrainIntegrationMutation>;
export type DeleteLogDrainIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteLogDrainIntegrationMutation, DeleteLogDrainIntegrationMutationVariables>;
